/**
 * Based on https://utrack.cloudberrylab.com/articles/BACKUP-A-40/Solution
 * There are the same codes for:
 * ChangeNetworkPassword (ChangeNetworkCredentials)
 * ChangePasswordAndRestart (ChangeRestorePasswordAndRunPlan)
 * OpenCbbService (ChangeServiceUser)
 * OpenDateTime (ChangeDateTime)
 * OpenNotSupportedForm (ChangeEdition)
 * OpenRestoreVerificationWindow (ChangeRvSettingsRunNewRV)
 * @see LastRunInfo
 */
export enum RecoveryErrorSolutionName {
  ChangeAuthForm = 'ChangeAuthForm',
  ChangeCostEstimatesForMBS = 'ChangeCostEstimatesForMBS',
  ChangeNetworkPassword = 'ChangeNetworkPassword', // The same as ChangeNetworkCredentials
  ChangeNetworkCredentials = 'ChangeNetworkCredentials', // The same as ChangeNetworkPassword
  ChangePasswordAndRestart = 'ChangePasswordAndRestart', // The same as ChangeRestorePasswordAndRunPlan
  ChangeRestorePasswordAndRunPlan = 'ChangeRestorePasswordAndRunPlan', // The same as ChangePasswordAndRestart
  ChangeSQLTempFolder = 'ChangeSQLTempFolder',
  ChangeStorageAccount = 'ChangeStorageAccount',
  ChangeTempFolder = 'ChangeTempFolder',
  DecryptBitlockerVolume = 'DecryptBitlockerVolume',
  DeletePlan = 'DeletePlan',
  DisableChunkTransparency = 'DisableChunkTransparency',
  DisableFilenameEncryption = 'DisableFilenameEncryption',
  DisableSkipExistingFiles = 'DisableSkipExistingFiles',
  EnableOverWriteExistVM = 'EnableOverWriteExistVM',
  EnableSkipOnDemandFile = 'EnableSkipOnDemandFile',
  ExcludePath = 'ExcludePath',
  IncludeUserInGroup = 'IncludeUserInGroup',
  KeepBitLocker = 'KeepBitLocker',
  OpenAdvancedOption = 'OpenAdvancedOption',
  OpenMemorySettings = 'OpenMemorySettings',
  OpenAdvancedFilter = 'OpenAdvancedFilter',
  OpenCbbService = 'OpenCbbService', // The same as ChangeServiceUser
  ChangeServiceUser = 'ChangeServiceUser', // The same as OpenCbbService
  OpenDateTime = 'OpenDateTime', // The same as ChangeDateTime
  ChangeDateTime = 'ChangeDateTime', // The same as OpenDateTime
  OpenEditWizard = 'OpenEditWizard',
  OpenNotSupportedForm = 'OpenNotSupportedForm', // The same as ChangeEdition
  ChangeEdition = 'ChangeEdition', // The same as OpenNotSupportedForm
  OpenRestoreVerificationWindow = 'OpenRestoreVerificationWindow', // The same as ChangeRvSettingsRunNewRV
  ChangeRvSettingsRunNewRV = 'ChangeRvSettingsRunNewRV', // The same as OpenRestoreVerificationWindow
  OpenScheduleWindow = 'OpenScheduleWindow',
  OpenRetentionPolicy = 'OpenRetentionPolicy',
  ReportIssue = 'ReportIssue', // TODO: Space in doc?
  SavePlan = 'SavePlan',
  RunFixVssTool = 'RunFixVssTool',
  RunFullBackup = 'RunFullBackup',
  SelectAvailableSource = 'SelectAvailableSource',
  ShowAccessDeniedPaths = 'ShowAccessDeniedPaths',
  ShowFailedItemsInHistory = 'ShowFailedItemsInHistory',
  ShowPlanById = 'ShowPlanById',
  ShowRestorePoint = 'ShowRestorePoint',
  ViewHistory = 'ViewHistory',
  EnableProceedRestoreVerification = 'EnableProceedRestoreVerification',
  Error1008 = 'Error1008', // This solution does not exist for Agent
  Error1503 = 'Error1503' // This solution does not exist for Agent
}

/**
 * There are special Errors without any solutions,
 * because Agent can`t do anything, but they need action
 */
export enum RecoveryErrorSpecialId {
  Error1008 = 1008,
  Error1503 = 1503
}

/**
 * Solutions for which an executor has been added. Which are clickable.
 */
export const ActiveSolutions: { [solutionName: string]: boolean } = {
  // Wizards
  [RecoveryErrorSolutionName.OpenEditWizard]: true,
  [RecoveryErrorSolutionName.OpenScheduleWindow]: true,
  [RecoveryErrorSolutionName.OpenAdvancedFilter]: true,
  [RecoveryErrorSolutionName.OpenRetentionPolicy]: true,
  [RecoveryErrorSolutionName.SelectAvailableSource]: true,

  // Edit options
  [RecoveryErrorSolutionName.OpenAdvancedOption]: true,
  [RecoveryErrorSolutionName.OpenMemorySettings]: true,
  [RecoveryErrorSolutionName.ChangeTempFolder]: true,
  [RecoveryErrorSolutionName.ChangeSQLTempFolder]: true,

  // Special
  [RecoveryErrorSolutionName.Error1008]: true,
  [RecoveryErrorSolutionName.Error1503]: true,

  // Plans actions
  [RecoveryErrorSolutionName.DeletePlan]: true,
  [RecoveryErrorSolutionName.RunFullBackup]: true,
  [RecoveryErrorSolutionName.SavePlan]: true,
  [RecoveryErrorSolutionName.KeepBitLocker]: true,
  [RecoveryErrorSolutionName.DisableChunkTransparency]: true,
  [RecoveryErrorSolutionName.DisableFilenameEncryption]: true,
  [RecoveryErrorSolutionName.DisableSkipExistingFiles]: true,
  [RecoveryErrorSolutionName.EnableOverWriteExistVM]: true,
  [RecoveryErrorSolutionName.EnableSkipOnDemandFile]: true,
  [RecoveryErrorSolutionName.OpenCbbService]: true,
  [RecoveryErrorSolutionName.ChangeServiceUser]: true,

  // History
  [RecoveryErrorSolutionName.ShowFailedItemsInHistory]: true,
  [RecoveryErrorSolutionName.ViewHistory]: true
};
